import { useState } from 'react';

const Notice = ({ notices = [] }) => {
    const [open, setOpen] = useState(false);
    const handleToggleOpenClick = () => setOpen(!open);
    return (
        <div className="snackbar-area">
            <div className={`notice-prev-header ${open ? 'open' : ''}`} onClick={handleToggleOpenClick}>
                <i className={`icon icon-info`}></i>
                <p>{notices[0].text}</p>
                <button type="button">
                    <i className="icon icon-arrow-down"></i>
                </button>
            </div>
            {open && <div className={`notice-prev-content open`} style={{ height: 'auto' }}>
                <ul>
                    {notices.slice(1).map((notice, index) => (
                        <li key={index} style={notice.style}>{notice.text}</li>
                    ))}
                </ul>
            </div>}
        </div>
    )
}

export default Notice;